import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { makeStyles } from "@material-ui/styles";

import { DIMENSIONS } from "../../constants/";
import breakpoints from "../../theme/breakpoints";

const themeBreakpoints = createBreakpoints(breakpoints);

const styles = makeStyles(() => ({
  navbarWrapper: {
    backgroundColor: "#FFA101",
    height: "40px",
    width: "100%",
    display: "flex",
    zIndex: 3000,
    position: "sticky",
    justifyContent: "center",
    top: 0,
  },
  navbarContentWrapper: {
    width: DIMENSIONS.MAIN_WRAPPER,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [themeBreakpoints.down("md")]: {
      width: DIMENSIONS.TABLET_WRAPPER,
    },
    [themeBreakpoints.down("sm")]: {
      padding: "20px 10px",
    },
  },
}));

export default styles;
